export default __webpack_public_path__ + "static/media/logo_MVX.ac7be265.svg";